import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ForBrands } from './pages/ForBrands';
import { ForMarketingAgencies } from './pages/ForMarketingAgencies';
import { ForTalent } from './pages/ForTalent';
import { CaseStudies } from './pages/CaseStudies';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-zano-pink/20" data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/for-brands" element={<ForBrands data-id="element-9" />} data-id="element-8" />
            <Route path="/for-marketing-agencies" element={<ForMarketingAgencies data-id="element-11" />} data-id="element-10" />
            <Route path="/for-talent" element={<ForTalent data-id="element-13" />} data-id="element-12" />
            <Route path="/case-studies" element={<CaseStudies data-id="element-15" />} data-id="element-14" />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail data-id="element-17" />} data-id="element-16" />
            <Route path="/pricing" element={<Pricing data-id="element-19" />} data-id="element-18" />
            <Route path="/login" element={<Login data-id="element-21" />} data-id="element-20" />
            <Route path="/terms-of-service" element={<TermsOfService data-id="element-23" />} data-id="element-22" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-25" />} data-id="element-24" />
            <Route path="/cookie-policy" element={<CookiePolicy data-id="element-27" />} data-id="element-26" />
          </Routes>
        </main>
        <Footer data-id="element-28" />
      </div>
    </BrowserRouter>;
}